<script>
export default {
  name: 'EditDealTab',
  functional: true,
  render: function(createElement, context) {
    return createElement(
      'div',
      {
        class: 'tabs__tab-pane',
        attrs: { id: context.props.id },
      },
      context.children,
    )
  },
}
</script>
